import React, { Component } from "react";

export class HeaderIntroLoans extends Component {
  render() {
    return (
      <div>
        <section id="intro" class="clearfix">
          <div class="container" data-aos="fade-up">
            <div class="intro-img" data-aos="zoom-out" data-aos-delay="200">
              <h4
                style={{
                  color: "#fff",
                  alignContent: "center",
                  justifyContent: "center",
                  alignSelf: "center",
                }}
              >
                Wish to speak to our Expert?
                <br />{" "}
              </h4>
              <p
                style={{
                  color: "#fff",
                  alignContent: "center",
                  fontSize: 14,
                  justifyContent: "center",
                  alignSelf: "center",
                }}
              >
                Please share your details. We assure to get back to you on
                priority.
              </p>

              <form onSubmit={this.onSubmit}>
                <div class="row">
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control form-control-md"
                      placeholder="Enter name"
                      name="name"
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                <br />
                <div class="row">
                  <div className="col-sm-10">
                    <input
                      type="number"
                      className="form-control form-control-md"
                      placeholder="Enter Mobile Number"
                      name="mobilenumber"
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                <br />
                <div class="row">
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control form-control-md"
                      placeholder="Enter Email"
                      name="emailid"
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                <br />

                <div class="row">
                  <div className="col-sm-10">
                    <select
                      name="classid"
                      className="form-control form-control-md"
                      onChange={this.onChange}
                    >
                      <option>Choose from our Services</option>
                      <option>Incometax E-Filing</option>
                      <option>GST Services</option>
                      <option>Company Secreterial Services</option>
                      <option>Investment Services</option>
                      <option>Loan</option>
                    </select>
                  </div>
                </div>
                <br />
                <button
                  variant="primary"
                  type="submit"
                  class="col-sm-10 btn btn-info"
                >
                  Submit
                </button>
              </form>
            </div>

            <div class="intro-info" data-aos="zoom-in" data-aos-delay="100">
              <h2>
              Avail Low Interest 
                <br />
                Rate Personal Loans 
                <br />
                from a wide range of 
                <br/>
                Lenders with ClipTax!


              </h2>
              <div>
                {/* <a href="#about" class="btn-get-started scrollto">
                    Get Started
                  </a> */}
                <a href="#services" class="btn-services scrollto">
                  Services Start as low as ₹49
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default HeaderIntroLoans;
